import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getAssetForumMessages } from 'src/api/stoApi';
import { ForumItem } from 'src/models';
import { generalStore } from 'src/stores/GeneralStore';

export const useForumDetails = (assetId: string, reload: boolean) => {
  const [forumMessages, setForumMessages] = useState<ForumItem[]>();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      setIsLoading(true);
      try {
        const response = await getAssetForumMessages(assetId);
        setForumMessages(response.data.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
        setIsLoading(false);
      }
    };
    if (assetId) {
      load();
    } else {
      setIsLoading(false);
    }
  }, [assetId, reload]);

  return { forumMessages, isLoading };
};
